import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-fretboard',
  templateUrl: './fretboard.component.html',
  styleUrls: ['./fretboard.component.scss'],
})
export class FretboardComponent implements OnInit {
  // Proposed inputs
  // Fret Range - Range of frets to show. 1-12
  // Notes - Which notes to show on the fretboard
  // Highlight Options - Some way to indicate which tones are highlighted.

  @Input() notes: Array<string> = [];

  constructor() {}

  ngOnInit(): void {}
}
